import { render, staticRenderFns } from "./ProjectLogsDialog.vue?vue&type=template&id=b1295ed0"
import script from "./ProjectLogsDialog.vue?vue&type=script&lang=js"
export * from "./ProjectLogsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports